/**
 * Prevent queryClient from using structural sharing
 */
export function preventStructuralSharing(_oldData: unknown, newData: unknown) {
  return newData;
}

export default preventStructuralSharing;
